/** @format */

import {useEffect} from 'react';

import {useLocation} from 'react-router-dom';
import {parseISO, isValid} from 'date-fns';

const RuDomain = 'adsensor.ru';
const DevPagesDomain = 'pages.dev';
//NOTE: специальный домен для добавления в реестр российского ПО
const RuRegistryDomain = 'ad-keeper.ru';

export const useBackgroundPath = () => {
  const location = useLocation();

  const {pathname, search} = location.state.background;
  return {pathname, search};
};

// https://reacttraining.com/react-router/web/example/query-parameters
export const useSearchParams = () => {
  const location = useLocation();
  return new URLSearchParams(location.search);
};

export const secondLevelDomain = () => {
  return window.location.hostname.split('.').slice(-2).join('.');
};

export const useCallbackOnReturn = (callback: () => void) => {
  const location = useLocation();

  useEffect(() => {
    callback();
  }, [location, callback]);
};

export const useDebugDate = (): Date | null => {
  const searchParams = useSearchParams();
  const dateOverride = searchParams.get('_date');
  if (dateOverride) {
    const parsed = parseISO(dateOverride);
    if (isValid(parsed)) return parsed;
  }
  return null;
};

export const IsRuVersion = () => {
  if (!import.meta.env.PROD) return true;

  if (secondLevelDomain() === DevPagesDomain) {
    return true;
  }
  if (secondLevelDomain() === RuRegistryDomain) {
    return true;
  }

  return secondLevelDomain() === RuDomain;
};
